import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import VCalendar from 'v-calendar'
import VueNumerals from 'vue-numerals'
import VueExcelXlsx from 'vue-excel-xlsx'

// createApp(App).use(router).mount('#app')
const myV3App = createApp(App)

myV3App
  .use(router)
  .use(VueSweetalert2)
  .use(VCalendar, {})
  .use(VueNumerals)
  .use(VueExcelXlsx)
// add more functionality to myV3App

// ******* Global Variables Assign before mounting ******* //
// (1). สำหรับตอนพัฒนา Develop
// myV3App.config.globalProperties.http_baseurl = 'http://localhost/mlab/src/service/'
// (2). สำหรับตอน Production
myV3App.config.globalProperties.http_baseurl = 'http://www.labsmartsoft.com/mlab/service/'
// ****************************************************** //

// Login Variables
myV3App.config.globalProperties.CorpID = 1
myV3App.config.globalProperties.UserID = 0
myV3App.config.globalProperties.UserName = 'Noppon'
myV3App.config.globalProperties.OfficialName = 'Thamwiwat'

// now we're ready to mount
myV3App.mount('#app')
